/*
 * @Author: 张印 hbzyin@163.com
 * @FilePath: /mall-fe/src/api/user.ts
 * @Description: 用户相关API
 *
 */
import { BANNER_TYPE_ENUM, CartTypeEnum } from 'libs/enums';
import { fetch } from 'libs/fetch';
const MINI_APP_ID = 'wx8994560be51e059f';
/**
 * 绑定严选账户与小程序
 * @param options
 */
export async function BindAuthWithWxCode(openId) {
  const res = await fetch('/api/shoper/v2/wxMini/bind', {
    method: 'POST',
    json: { openId, appId: MINI_APP_ID },
  });
  return res;
}

/**
 * 取消绑定关系
 * @param options
 */
export async function unBindAuthWithWxCode() {
  const openId = localStorage.getItem('openId');
  const res = await fetch('/api/shoper/v2/wxMini/unBind', {
    method: 'POST',
    json: { openId, appId: MINI_APP_ID },
  });
  return res;
}

/**
 * 获取用户信息
 * @param options
 */
export async function getUserDetail(options?: FetchOptions) {
  const res = await fetch('/api/basic/v1/authUser/getUserDetail', options);
  return res;
}

/**
 * 获取手机验证码
 * @param options
 */
export async function phoneCode(options?: FetchOptions) {
  const res = await fetch('/api/mall/v1/kaptcha/verifyKaptcha/phoneCode', options);
  return res;
}

export async function apiConfirmAnnouncement(json) {
  return await fetch('/api/ifs/v1/basisAnnouncementReadRecord/addTemp', {
    json,
    method: 'POST',
  });
}

/**
 * 校验手机号码是否重复
 * @param options
 */
export async function validPhone(options?: FetchOptions) {
  const res = await fetch('/api/mall/v1/supplier/validLoginNameAndPhone', options);
  return res;
}

/**
 * 验证企业信息
 * @param options
 */
export async function verifyCompany(options?: FetchOptions) {
  const res = await fetch('/api/tender/v1/supplier/verifyCompany', options);
  return res;
}

/**
 * 获取地区
 * @param options
 */
export async function getAreas(options?: FetchOptions) {
  const res = await fetch('/api/mall/v1/mallArea/areas', options);
  return res;
}

/**
 * 用户注册
 * @param options
 */
export async function registerUser(options?: FetchOptions) {
  const res = await fetch('/api/tender/v1/supplier/userRegister', options);
  return res;
}

/**
 * 企业认证
 * @param options
 */
export async function supplierRegister(options?: FetchOptions) {
  const res = await fetch('/api/tender/v1/supplier/supplierRegister', options);
  return res;
}

/**
 * 经营品类枚举
 * @param options
 */
export async function getCategoryList(options?: FetchOptions) {
  const res = await fetch('/api/tender/v1/supplier/getCategoryList', options);
  return res;
}

/**
 * 获取配置信息
 * @param options
 */
export async function getConfiguration(options?: FetchOptions) {
  const res = await fetch('/api/basic/v1/configuration/', options);
  return res;
}

/**
 * 获取配置信息:不需要登陆
 * @param options
 */
export async function getRuntimeConfiguration(options?: FetchOptions) {
  const res = await fetch('/api/basic/v1/configuration/runtime', options);
  return res;
}

/**
 * 获取供应商认证信息
 * @param options
 */
export async function getSupplierInfo(options?: FetchOptions) {
  const res = await fetch('api/tender/v1/supplier/userSysNo/get', options);
  return res;
}

/**
 * 保存用户信息
 * @param options
 */
export async function saveUser(json) {
  const res = await fetch(`/api/ifs/v1/sso/saveUser`, {
    needLogin: true,
    wantError: true,
    json,
    method: 'POST',
  });
  return res;
}

/**
 * 获取用户信息
 * @param options
 */
export async function loadUser() {
  const res = await fetch(`/api/ifs/v1/sso/loadUser`, {
    method: 'POST',
    needLogin: true,
  });
  return res;
}

/**
 * 修改密码
 * @param options
 */
export async function changePassword(json) {
  const res = await fetch(`/api/ifs/v1/sso/change/password`, {
    needLogin: true,
    wantError: true,
    json,
    method: 'POST',
  });
  return res;
}

/**
 * 验证验证码
 * @param options
 */
export async function phoneCodeVerify(options?: FetchOptions) {
  const res = await fetch(`/api/ifs/v1/sso/verifyKaptcha/phoneCodeVerify`, options);
  return res;
}

/**
 * 找回密码
 * @param options
 */
export async function backPassword(json) {
  const res = await fetch(`/api/ifs/v1/sso/back/password`, {
    wantError: true,
    json,
    method: 'POST',
  });
  return res;
}

/**
 * 修改手机号
 * @param options
 */
export async function changePhone(json) {
  const res = await fetch(`/api/ifs/v1/sso/change/phone`, {
    needLogin: true,
    wantError: true,
    json,
    method: 'POST',
  });
  return res;
}

/**
 * 登录
 * @param options
 */
export async function login(options?: FetchOptions) {
  const res = await fetch(`/api/ifs/v1/sso/login`, options);
  return res;
}

/**
 * 添加留言
 * @param options
 */
export async function addGuestBook(options?: FetchOptions) {
  const res = await fetch('/api/tender/v1/guestBook/add', options);
  return res;
}

/**
 * 生成握手字符串
 * @param options
 */
export async function generateHandShakeMessage(options?: FetchOptions) {
  const res = await fetch('/api/ifs/v1/handShakeMessage/generateHandShakeMessage', options);
  return res;
}

/**
 * 获取职业信息
 * @param options
 */
export async function loadProfessionDetail() {
  const res = await fetch('/api/ifs/v1/authUserProfession/detail', {
    needLogin: true,
  });
  return res;
}

/**
 * 保存职业信息
 * @param json
 */
export async function saveProfessionDetail(json) {
  const res = await fetch('/api/ifs/v1/authUserProfession/save', {
    needLogin: true,
    json,
    method: 'POST',
    wantError: true,
  });
  return res;
}

/**
 * 根据level获取地区信息
 * @param options
 */
export async function areaDataByCondition(query) {
  const res = await fetch('/api/ifs/v1/basis/area/searchByCondition', { query });
  return res;
}

/**
 * 获取省市级联地区
 */
export async function getSelectCascadeArea() {
  const res = await fetch('/api/ifs/v1/basis/area/getSelectCascadeArea', {});
  return res;
}

/**
 * 根据sysNo获取地区信息
 * @param options
 */
export async function areaDataBySysNo(query) {
  const res = await fetch('/api/ifs/v1/basis/area/areaTree', { query });
  return res;
}

/**
 * 从服务端获取协议
 * @param options
 */
export async function getAgreementNewest(json) {
  const res = await fetch('/api/ifs/v1/basis/agreement/newest', {
    json,
    method: 'POST',
    wantError: true,
  });
  return res;
}

/**
 * 同意登录协议
 * @param options
 */
export async function agreeAgreement(json) {
  const res = await fetch(`/api/ifs/v1/sso/agreeAgreement`, {
    json,
    method: 'POST',
    wantError: false,
  });
  return res;
}

/**
 * 登录时获取手机验证码
 * @param options
 */
export async function resendSmsVerificationCode(json) {
  const res = await fetch(`/api/ifs/v1/sso/resendSmsVerificationCode`, {
    json,
    method: 'POST',
    wantError: true,
  });
  return res;
}

/**
 * 登录时校验验证码并且登录
 * @param options
 */
export async function verifySmsCode(json) {
  const res = await fetch(`/api/ifs/v1/sso/verifySmsCode`, {
    json,
    method: 'POST',
    wantError: false,
  });
  return res;
}

/**
 * 获取集团验证码SDK初始化相关参数
 */
export async function gtRegister() {
  const res = await fetch(
    '/api/ifs/v1/slideVerify/register?t=' + new Date().getTime(),
    // "/v1/slideVerify/register?t=" + new Date().getTime(),
    {
      method: 'GET',
    },
  );
  return res;
}

/**
 * 短信验证码V2，用新的验证码SDK
 */
export async function phoneCodeV2(json, smsType: SmsType) {
  const res = await fetch(`/api/basic/v2/sso/verifyKaptcha/phoneCode`, {
    json: {
      ...json,
      smsType,
    },
    method: 'POST',
  });
  return res;
}

/**
 * 登录V2，同样替换了验证码
 */
export async function loginV2(options?: FetchOptions) {
  const res = await fetch(`/api/basic/v2/sso/login`, options);
  return res;
}

/**
 * 登录, thirdParty， e.g. 数字口袋
 */
export async function loginForThirdParty(options?: FetchOptions) {
  const res = await fetch(`/api/ifs/v2/sso/loginForThirdParty`, options);
  return res;
}

/**
 * 登录V2，验证码登录
 */
export async function loginV2Code(options?: FetchOptions) {
  const res = await fetch(`/api/basic/v2/sso/loginBySmsCode`, options);
  return res;
}

/**
 * 异地登录，验证码V2版
 */
export async function resendSmsVerificationCodeV2(json) {
  const res = await fetch(`/api/ifs/v2/sso/resendSmsVerificationCode`, {
    json,
    method: 'POST',
    wantError: true,
  });
  return res;
}

/**
 * 拿微信jssdk初始化需要的配置
 */
export async function getWxSdkConfig(url: string) {
  const res = await fetch(`/api/ifs/v1/wx/generateJSSDKSignature`, {
    method: 'POST',
    json: { url },
  });
  return res;
}

/**
 * 校验注册名称是否已存在
 */
export async function verifyCorpAuthenticated(json) {
  const res = await fetch(`/api/ifs/v1/basis/supplier/verifyCorpAuthenticated`, {
    method: 'POST',
    json,
  });
  return res;
}

/**
 * 校验租户注册名称是否已存在
 */
export async function verifyCorpAuthenticatedWithTenant(json) {
  const res = await fetch(`/api/ifs/v1/basis/supplier/verifyCorpAuthenticatedWithTenant`, {
    method: 'POST',
    json,
  });
  return res;
}

/**
 * 添加留言V2，同样使用gt验证码
 */
export async function addGuestBookV2(options?: FetchOptions) {
  const res = await fetch('/api/tender/v2/guestBook/add', options);
  return res;
}

/**
 * 获取logo/header/footer配置
 */
export async function getNavConfig(options?: FetchOptions) {
  const res = await fetch(`/api/ifs/v1/commonDictionary/navigatorConfig`, options);
  return res;
}

/**
 * 获取首页静态数据
 */
export async function getIndexStatistics(options?: FetchOptions) {
  const res = await fetch(`/api/ifs/v1/index/getStatistics`, {
    ...options,
    method: 'POST',
  });
  return res;
}

/**
 * 校验是否包含敏感词
 */
export async function verificationText(json) {
  const res = await fetch(`/api/tech/recognition/text/verification`, {
    json,
    method: 'POST',
  });
  return res;
}

/**
 * 获取热搜词
 */
export async function getHotWord(options?: FetchOptions) {
  const res = await fetch(`/api/mall/v1/hotWord/get`, {
    ...options,
    method: 'POST',
  });
  return res;
}

/**
 * 发送跟踪数据给中台
 */
export async function trackRecord(json: TrackingRecord, options?: FetchOptions) {
  const res = await fetch(`/api/ifs/v1/basisUserTrackRecord/record`, {
    method: 'POST',
    json,
    ...options,
  });
  return res;
}

/**
 * 正常注册
 * @param json
 * @param options
 */
export async function userRegister(json, options?: FetchOptions) {
  const res = await fetch('/api/ifs/v1/authUser/userRegister', {
    method: 'POST',
    json,
    ...options,
  });
  return res;
}

/**
 * 引流注册
 * @param json
 * @param options
 */
export async function userFastRegister(json, options?: FetchOptions) {
  const res = await fetch('/api/ifs/v1/authUser/userFastRegister', {
    method: 'POST',
    json,
    ...options,
  });
  return res;
}

/**
 * 短信验证码V2，用于申请开通账号
 */
export async function sendDefaultSmsVerificationCode(json) {
  const res = await fetch(`/api/ifs/v2/sso/sendDefaultSmsVerificationCode`, {
    json: {
      ...json,
    },
    method: 'POST',
  });
  return res;
}

/**
 * 申请开通账号
 */
export async function applyOpen(json, options?: FetchOptions) {
  const res = await fetch(`/api/ifs/v1/tenant/permission/applyOpen`, {
    json: {
      ...json,
    },
    method: 'POST',
    ...options,
  });
  return res;
}

/**
 * 用户认证状态
 */
export async function checkAuthStatus(options?: FetchOptions) {
  const res = await fetch(`/api/ifs/v1/basis/supplier/checkAuthStatus`, {
    method: 'GET',
    ...options,
  });
  return res;
}

export async function checkMemberLevel(
  json: {
    userType?: number; // 1是采购商，2是供应商
    businessType: number;
    businessSysNo: string;
  },
  options?: FetchOptions,
) {
  const res = await fetch(`/api/tender/v1/platform/portal/member/checkMemberLevel`, {
    json: {
      ...json,
      userType: json.userType ? json.userType : 2,
    },
    method: 'POST',
    ...options,
  });
  return res;
}

export async function isReferrerSearchEnable() {
  const res = await fetch<boolean>('/api/ifs/v1/basis/referrer/enabled', {});
  return res;
}

export async function searchReferrer(keyword?: string, pageSize = 999, pageNo = 1) {
  const res = await fetch('/api/ifs/v1/basis/referrer/searchByPage', {
    method: 'POST',
    json: {
      keyword,
      pageSize,
      pageNo,
    },
  });
  return res;
}

/**
 * check是否绑定微信，
 * 如果已经绑定直接登录，
 * 如果没有绑定则返回wx-token，
 * 登录的时候给后端传过去用于绑定
 */
export async function wxMpLogin(query) {
  const res = await fetch(`/api/ifs/v1/wx/wxMpLogin`, { query, method: 'POST' });
  return res;
}

/**
 * 解绑微信
 * @param query
 * @returns
 */
export async function wxUnbind(query) {
  const res = await fetch(`/api/ifs/v1/wx/unbind`, { query, method: 'POST' });
  return res;
}

/**
 * 清除cookie
 * @param query
 * @returns
 */
export async function clearCookie() {
  const res = await fetch(`/api/ifs/v1/sso/clearCookie`, { method: 'GET' });
  return res;
}

/**
 * check是否有Guidance
 * @returns
 */
export async function checkGuidance() {
  const res = await fetch(`/api/ifs/v1/sso/userGuidance`, {
    method: 'GET',
    wantError: true,
  });
  return res;
}

/**
 * 获取微信名和头像
 * @returns
 */
export async function wxSnsLoginUserInfo(query) {
  const res = await fetch(`/api/ifs/v1/wx/wxSnsLogin/userInfo`, {
    query,
    method: 'GET',
  });
  return res;
}

/**
 * 绑定微信
 * @returns
 */
export async function wxSnsLoginBindUser(json) {
  const res = await fetch(`/api/ifs/v1/wx/wxSnsLogin/bindUser`, {
    json,
    method: 'POST',
    wantError: true,
  });
  return res;
}

/**
 * 解绑微信
 * @returns
 */
export async function wxSnsBindUnbind() {
  const res = await fetch(`/api/ifs/v1/wx/wxSnsBind/unbind`, {
    method: 'POST',
  });
  return res;
}

/**
 * 获取微信扫码登录的state
 * @returns
 */
export async function wxSnsLoginState() {
  const res = await fetch(`/api/ifs/v1/wx/wxSnsLogin/state`, {
    method: 'GET',
  });
  return res;
}

/**
 * 找回账号提交申请
 * @returns
 */
export async function retrieveAccount(json) {
  const res = await fetch(`/api/ifs/v1/authUser/retrieve/front/account`, {
    json,
    method: 'POST',
  });
  return res;
}

/**
 * 找回密码（手机不可用）情况下，不可用的手机号校验
 */
export async function validateUnavailableMobile(json = {}) {
  const res = await fetch('/api/ifs/v1/authUser/retrieve/front/validateUnavailableMobile', {
    method: 'POST',
    json,
  });
  return res;
}

/**
 * 找回密码（手机不可用）提交申请
 */
export async function frontPassword(json = {}) {
  const res = await fetch('/api/ifs/v1/authUser/retrieve/front/password', {
    method: 'POST',
    json,
  });
  return res;
}

/*
 * 供应商体验期会员开关
 * @returns
 */
export async function probationConfig() {
  const res = await fetch(`/api/supplier/v1/supplier/basis/member/config/probation/search`, {
    method: 'GET',
  });
  return res;
}

/**
 * 找回密码（手机不可用）提交申请
 */
export async function checkMobileExist(json = {}) {
  const res = await fetch('/api/ifs//v1/authUser/checkMobileExist', {
    method: 'POST',
    wantError: true,
    json,
  });
  return res;
}

// 获取默认区域code
export async function getAreaId() {
  const res = await fetch(`/api/mall/v1/mallArea/getArea?_t=${Date.now()}`, {
    method: 'GET',
  });
  return res;
}

export async function getFirstTownOfProvinceCode(areaSysNo: string) {
  const res = await fetch(`/api/mall/v1/mallArea/firstTownOfProvince/${areaSysNo}`, {
    method: 'GET',
  });
  return res;
}

export async function getFirstTownOfCityCode(areaSysNo: string) {
  const res = await fetch(`/api/mall/v1/mallArea/firstTownOfCity/${areaSysNo}`, {
    method: 'GET',
  });
  return res;
}

//普通购物车数量
export async function getShoppingCartQuantity(json = {}) {
  const res = await fetch('/api/mall/v1/purchaser/shoppingCart/quantity', {
    method: 'POST',
    json,
  });
  return res;
}

//招采购物车数量
export async function getTenderShoppingCartQuantity(json = {}) {
  const res = await fetch('/api/tender/v1/purchaser/shoppingCart/quantity', {
    method: 'POST',
    json,
  });
  return res;
}

//普通购物车
export async function getShoppingCartList(json = {}) {
  const res = await fetch('/api/mall/v1/purchaser/shoppingCart/list', {
    method: 'POST',
    json,
  });
  return res;
}

//招采购物车
export async function getTenderShoppingCartList(json = {}) {
  const res = await fetch('/api/tender/v1/purchaser/shoppingCart/list', {
    method: 'POST',
    json,
  });
  return res;
}

//购物车数据
export async function getShoppingCart(json: {
  type: CartTypeEnum;
  areaSysNo: string | number;
  paymentSysNoObj?: any[];
  frontDefaultTradeMethodList?: any[];
}) {
  const res = await fetch('/api/mall/v1/purchaser/shoppingCart/get', {
    method: 'POST',
    json,
  });
  return res;
}

//新的购物车数据接口，规则和交易方式放在了后端存储
export async function getShopShoppingCart(json: {
  type: CartTypeEnum;
  areaSysNo: string | number;
}) {
  const res = await fetch('/api/mall/v1/purchaser/shoppingCart/getShop', {
    method: 'POST',
    json,
  });
  return res;
}

/**
 * 添加购物车
 * @param json
 * @returns
 */
export async function addCartGoods(json: AddCartGoodsProps) {
  return await fetch('/api/mall/v1/purchaser/shoppingCart/add', {
    method: 'post',
    json,
  });
}

/**
 * 批量添加购物车
 * @param json
 * @returns
 */
export async function addCartGoodsList(json: any) {
  return await fetch('/api/mall/v1/purchaser/shoppingCart/addList', {
    method: 'post',
    json,
  });
}

/**
 * 更新购物车商品数量
 * @param sysNoList
 * @returns
 */
export async function updateCartGoods(sysNo: string, quantity: number) {
  return await fetch('/api/mall/v1/purchaser/shoppingCart/update', {
    method: 'post',
    json: {
      sysNo,
      quantity,
    },
  });
}

/**
 * 删除购物车商品
 * @param sysNoList
 * @returns
 */
export async function removeCartGoods(sysNoList: string[]) {
  return await fetch('/api/mall/v1/purchaser/shoppingCart/remove', {
    method: 'post',
    json: {
      sysNoList,
    },
  });
}

/**
 * 购物车提交preCheck
 * @param json
 * @returns
 */
export async function shopSimulateSplit(json: {}) {
  return await fetch('/api/mall/v1/purchaser/trade/shopSimulateSplit', {
    method: 'post',
    json,
  });
}

export async function getContractDetail(id) {
  const res = await fetch(`/api/tender/v1/purchaser/contract/supplyChain/detail/${id}`, {
    method: 'GET',
  });
  return res;
}

// 获取商品分类
export async function getCategory(options?: FetchOptions) {
  const res = await fetch(`/api/mall/v1/category/list`, {
    ...options,
    method: 'POST',
  });
  return res;
}

/**
 * 获取banner
 * @param type
 * @returns
 */
export async function getBanner(type: BANNER_TYPE_ENUM, options?: FetchOptions) {
  // const res = await fetch(`http://mall-dev.3jyx.cn/api/mall/v1/mall/getBanners/${type}`, {
  const res = await fetch(`/api/mall/v1/mall/getBanners/${type}`, {
    method: 'GET',
    ...options,
  });
  return res;
}

/**
 * 查询新开项目列表
 * @param type
 * @returns
 */
export async function apiGetProjectNewAddList(options?: FetchOptions) {
  const res = await fetch(`/api/basic/v2/newProject/queryNewProjectByPage`, {
    method: 'POST',
    ...options,
  });
  return res;
}
/**
 * 查询新开项目详情
 * @param type
 * @returns
 */
export async function apiGetProjectNewAddDetail(options?: FetchOptions) {
  const res = await fetch(`/api/basic/v2/newProject/queryProjectDetailById`, {
    method: 'GET',
    ...options,
  });
  return res;
}

/**
 * 查询厂家直采列表
 * @param type
 * @returns
 */
export async function apiGetFactoryDirectList(options?: FetchOptions) {
  const res = await fetch(`/api/mall/v1/manufacturerSupply/search`, {
    method: 'POST',
    ...options,
  });
  return res;
}

/**
 * 查询平台动态列表
 * @param options
 */
export async function getNewsData(options?: FetchOptions) {
  const res = await fetch('/api/ifs/v1/index/getNewsData', {
    ...options,
    method: 'POST',
  });
  return res;
}

/**
 * 获取商务信息
 */
export async function getBusinessDetail(sysNo, options?: FetchOptions) {
  const res = await fetch(`/api/supplier/v2/profileBusiness/getBusinessV2/${sysNo}`, {
    method: 'GET',
    ...options,
  });
  return res;
}

/**
 * 获取认证信息
 */
export async function getAuthDetail(supplierSysNo, options?: FetchOptions) {
  const res = await fetch(`/api/supplier/v2/basis/supplier/getAuthDetail`, {
    method: 'POST',
    json: {
      supplierSysNo,
    },
    ...options,
  });
  return res;
}

/**
 * 获取枚举值
 */
export async function commonDictionaryEnumState(options?: FetchOptions) {
  const res = await fetch(`/api/supplier/v1/supplier/enum`, {
    method: 'GET',
    ...options,
  });
  return res;
}

export async function qualificationEncoding(options?: FetchOptions) {
  const res = await fetch(`/api/ifs/v1/commonDictionary/supplier/qualification/encoding`, {
    method: 'GET',
    ...options,
  });
  return res;
}

export async function categoryTree(options?: FetchOptions) {
  const res = await fetch(`/api/supplier/v2/admittance/category/tree`, {
    method: 'GET',
    ...options,
  });
  return res;
}

export async function getSkuStatisticsInfo(areaCode: string, options?: FetchOptions) {
  const res = await fetch(`/api/material/v1/lange/getSkuStatisticsInfo/${areaCode}`, {
    method: 'GET',
    ...options,
  });
  return res;
}

export async function getWaitAuditShop(options?: FetchOptions) {
  const res = await fetch('/api/tender/v1/admin/statistics/getWaitAuditShop', {
    method: 'GET',
    ...options,
  });
  return res;
}

export async function getBasicSupplierInfo(supplierSysNo, options?: FetchOptions) {
  const res = await fetch(`/api/supplier/v2/basis/supplier/get?supplierSysNo=${supplierSysNo}`, {
    method: 'GET',
    ...options,
  });
  return res;
}

// 价格显示逻辑 全局配置
export async function showGoodsPricePermission(options?: FetchOptions) {
  const res = await fetch(`/api/mall/v1/mall/showGoodsPricePermission`, {
    ...options,
    method: 'GET',
  });
  return res;
}

export async function authSubject(subjectId: string, password: string, options?: FetchOptions) {
  const res = await fetch(`/api/ifs/v1/auth/subject/authorize`, {
    ...options,
    json: {
      subjectId,
      password,
    },
    wantError: true,
    method: 'POST',
  });
  return res;
}

/**
 * 切换身份
 */
export async function changeApp(sysNo: string) {
  const res = await fetch(`/api/ifs/v1/authApplication/change/${sysNo}`, {
    method: 'POST',
    needLogin: true,
  });
  return res;
}

// 未读消息
export async function unreadNum() {
  const res = await fetch(`/api/ifs/v1/notify/message/unreadNum`, {
    method: 'POST',
  });
  return res;
}

// 审批
export async function pendingTaskList(options) {
  const res = await fetch(`/api/workflow/instance/info/pendingTaskList`, {
    method: 'POST',
    ...options,
  });
  return res;
}

export async function searchBulletin(options?: FetchOptions) {
  const res = await fetch<PaginationResponse<any>>('/api/ifs/v1/announcement/page', {
    ...options,
    method: 'POST',
  });

  return res;
}

export async function searchNewBulletin(options?: FetchOptions) {
  const res = await fetch<PaginationResponse<any>>('/api/ifs/v1/announcement/newPage', {
    ...options,
    method: 'POST',
  });

  return res;
}

// 批量更新购物车数据
export async function shoppingCartBatchUpdate(options) {
  const res = await fetch(`/api/mall/v1/purchaser/shoppingCart/batchUpdate`, {
    method: 'POST',
    ...options,
  });
  return res;
}

export async function checkUserHaveRead() {
  const res = await fetch(`/api/ifs/v1/announcement/checkUserHaveRead`, {
    method: 'POST',
  });
  return res;
}

/**
 * 公告和消息未读数量计数
 */
export async function getAllUnreadNum(json) {
  const res = await fetch(`/api/ifs/v1/announcement/notify/message/allUnreadNum`, {
    method: 'POST',
    json,
  });
  return res;
}

/**
 * 获取未处理待办数量
 * */
export async function unreadTodoNum(json = {}) {
  const res = await fetch(`/api/ifs/v1/notify/tasktodo/unMobileProcessNum`, {
    method: 'POST',
    json,
  });
  return res;
}

/**
 * 分页获取公告列表
 */
export async function getAnnouncement(json) {
  const res = await fetch('/api/ifs/v1/announcement/page', {
    method: 'POST',
    json,
  });
  return res;
}

/**
 * ● 获取公告详情
 */
export async function getAnnouncementDetail(sysNo) {
  const res = await fetch(`/api/ifs/v1/announcement/get/${sysNo}`, {
    method: 'GET',
  });
  return res;
}

/**
 * 公告置为已读
 */
export async function announcementRead(json) {
  const res = await fetch('/api/ifs/v1/basisAnnouncementReadRecord/add', {
    method: 'POST',
    json,
  });
  return res;
}

/**
 * 切换身份
 */
export async function authApplicationChange(type) {
  const res = await fetch(`/api/ifs/v1/authApplication/change/${type}`, {
    method: 'POST',
  });
  return res;
}

/**
 * 是否实名
 */
export async function checkAuthentication(sysNo) {
  const res = await fetch(`/api/ifs/v1/authUser/checkAuthentication/${sysNo}`, {
    method: 'POST',
  });
  return res;
}

/**
 * 退出登录
 * @param query
 * @returns
 */
export async function toLogout() {
  const res = await fetch(`/api/basic/v2/sso/union/logout`, { method: 'GET' });
  return res;
}

export async function apiGetServiceOpenStatus() {
  return fetch('/api/ifs/v1/basis/switch/queryBasisSwitchConfig', {
    method: 'POST',
    json: {
      switchType: 1,
    },
  });
}
